import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    browserURL: "https://biobigdata.nju.edu.cn/browser/?genome=cornus_wilsoniana&gftk=pcGene,full"
  },
  getters: {
  },
  mutations: {
    updateURL(state, newURL) {
      state.browserURL = newURL
    }
  },
  actions: {
  },
  modules: {
  }
})
